module.exports = __webpack_public_path__ + "static/logo-eca71072f73c3ab23a52f49fdb9b86a2.webp";